import React, { FC } from "react"
import { RouteComponentProps } from '@reach/router';
import { getEntity } from './tenant.reducer';
import { connect } from 'react-redux';
import DetailsPage, { DetailsStateAndDispatchProps } from "layouts/page-wraper/details-page";
import { RootState } from "reducers";
import ProDescriptions from "@ant-design/pro-descriptions";
import { Tenant } from "model/system/tenant";

export interface TenantDetailsProps extends DetailsStateAndDispatchProps<Tenant, 'tenantStatus'>,
  RouteComponentProps, StateProps, DispatchProps {
}

const TenantDetails: FC<TenantDetailsProps> = (props: any) => {

  return (
    <DetailsPage<Tenant>
      title='商城详情'
      hideEdit={true}
      {...props}
    >
      <ProDescriptions<Tenant>
        columns={props.columns}
        dataSource={props.entity}
        column={2}
      >
      </ProDescriptions>
    </DetailsPage>);
};

const mapStateToProps = ({ tenant }: RootState) => ({
  entity: tenant.entity,
});

const mapDispatchToProps = {
  getEntity
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(TenantDetails);
